import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { HttpHeaders } from '@angular/common/http';
import { io, Socket } from 'socket.io-client';
import { SocketService } from './socket.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {

  private baseUrl = environment.baseUrl;
  private pythonGroupUrl: any = environment.baseUrlBrowser
  socket = this.socketService.socket;
  constructor(private http: HttpClient,private commonService : CommonService,
    private socketService : SocketService) { }

  ngOnInit(){
    this.socket.on('user.settings.groups.created', function(group) {
      //$rootScope.$broadcast('user.settings.groups.created', group)
      //$rootScope.$apply()
    })
  
    this.socket.on('user.settings.groups.deleted', function(group) {
      //$rootScope.$broadcast('user.settings.groups.deleted', group)
      //$rootScope.$apply()
    })
  
    this.socket.on('user.settings.groups.updated', function(group) {
      //$rootScope.$broadcast('user.settings.groups.updated', group)
      //$rootScope.$apply()
    })
  
    this.socket.on('user.view.groups.created', function(group) {
      //$rootScope.$broadcast('user.view.groups.created', group)
      //$rootScope.$apply()
    })
  
    this.socket.on('user.view.groups.deleted', function(group) {
      //$rootScope.$broadcast('user.view.groups.deleted', group)
      //$rootScope.$apply()
    })
  
    this.socket.on('user.view.groups.updated', function(group) {
      //$rootScope.$broadcast('user.view.groups.updated', group)
      //$rootScope.$apply()
    })
  }

  getGroupUsers (id:any, fields:any) {
    return this.http.get(`${this.baseUrl}`+'/api/v1/groups/' + id + '/users?fields=' + fields)
  }

  getOboeGroupUsers (id:any, fields:any, addGroupUser:any) {
    // return oboe()(this.commonService.getBaseUrl()
    // + '/api/v1/groups/' + id + '/users?fields=' + fields)
    //   .node('users[*]', function(user) {
    //     addGroupUser(user)
    //   })
  }

  getGroupDevices (id:any, bookable:any, fields:any) {
    return this.http.get(`${this.baseUrl}`+'/api/v1/groups/' + id + '/devices?bookable=' + bookable + '&fields=' + fields)
  }

  getOboeGroupDevices (id:any, bookable:any, fields:any, addGroupDevice:any) {
    // return oboe()(this.commonService.getBaseUrl()
    // + '/api/v1/groups/' + id + '/devices?bookable=' + bookable + '&fields=' + fields)
    //   .node('devices[*]', function(device) {
    //     addGroupDevice(device)
    //   })
  }

  getGroupDevice (id:any, serial:any, fields:any) {
    return this.http.get(`${this.baseUrl}`+'/api/v1/groups/' + id + '/devices/' + serial + '?fields=' + fields)
  }

  addGroupDevice (id:any, serial:any) {
    return this.http.put(`${this.baseUrl}`+'/api/v1/groups/' + id + '/devices/' + serial,null)
  }

  addGroupDevices (id:any, serials:any) {
    let data = (typeof serials === 'undefined' ? serials : JSON.stringify({serials: serials}));
    return this.http.put(`${this.baseUrl}`+'/api/v1/groups/' + id + '/devices',data);
  }

  removeGroupDevice (id:any, serial:any) {
    return this.http.delete(`${this.baseUrl}`+'/api/v1/groups/' + id + '/devices/' + serial)
  }

  removeGroupDevices (id:any, serials:any) {
    let data = (typeof serials === 'undefined' ? serials : JSON.stringify({serials: serials}));
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=utf-8',
      }),
      body: {
        data: data,
      },
    };
    return this.http.delete(`${this.baseUrl}`+'/api/v1/groups/' + id + '/devices',options);
  }

getBrowsersByGroup(id: any): Observable<any> {
  const payload = { group: id };
  return this.http.post(`${this.pythonGroupUrl}/getBrowsersByGroup`, payload);
}

getNonacquiredBrowsers(): Observable<any> {
  return this.http.get(`${this.pythonGroupUrl}/getNonacquiredBrowsers`);
}

addGroupBrowser(id: any, browserId: any): Observable<any> {
  const payload = { browserId: browserId, group: id };
  return this.http.post(`${this.pythonGroupUrl}/addBrowserToGroup`, payload);
}

addGroupBrowsers(id: any, browserIds: any): Observable<any> {
  let data = (typeof browserIds === 'undefined' ? browserIds : JSON.stringify({browserIds: browserIds}));
  return this.http.put(`${this.pythonGroupUrl}/addBrowsersToGroup/${id}`, data);
}


removeGroupBrowser(browserId: any): Observable<any> {
  const payload = { browserId: browserId };
  return this.http.post(`${this.pythonGroupUrl}/deallocateBrowserFromGroup`, payload);
}

removeGroupBrowsers(browserIds: any): Observable<any> {
  let data = (typeof browserIds === 'undefined' ? browserIds : JSON.stringify({browserIds: browserIds}));
  return this.http.post(`${this.pythonGroupUrl}/deallocateBrowsersFromGroup`, data);
}

getGroupBrowser(id: any, browserId: any, fields: any): Observable<any> {
  return this.http.get(`${this.pythonGroupUrl}/api/v1/groups/${id}/browsers/${browserId}?fields=${fields}`);
} 
  addGroupUser (id:any, email:any) {
    return this.http.put(`${this.baseUrl}`+'/api/v1/groups/' + id + '/users/' + email,null);
  }

  addGroupUsers (id:any, emails:any) {
    let data = (typeof emails === 'undefined' ? emails : JSON.stringify({emails: emails}));
    return this.http.put(`${this.baseUrl}`+'/api/v1/groups/' + id + '/users',data);
  }

  removeGroupUser (id:any, email:any) {
    return this.http.delete(`${this.baseUrl}`+'/api/v1/groups/' + id + '/users/' + email)
  }

  removeGroupUsers (id:any, emails:any) {
    let data = (typeof emails === 'undefined' ? emails : JSON.stringify({emails: emails}));
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=utf-8',
      }),
      body: {
        data: data,
      },
    };
    return this.http.delete(`${this.baseUrl}`+'/api/v1/groups/' + id + '/users',options);
  }

  getOboeGroups (addGroup:any) {
    // return oboe()(this.commonService.getBaseUrl() + '/api/v1/groups')
    //   .node('groups[*]', function(group) {
    //     addGroup(group)
    //   })
  }

  getGroups () {
    return this.http.get(`${this.baseUrl}`+'/api/v1/groups')
  }

  getOboeMyGroups (addGroup:any) {
    // return oboe()(this.commonService.getBaseUrl() + '/api/v1/groups?owner=true')
    //   .node('groups[*]', function(group) {
    //     addGroup(group)
    //   })
    return this.http.get(`${this.baseUrl}` + '/api/v1/groups?owner=true');
  }

  getMyGroups () {
    return this.http.get(`${this.baseUrl}`+'/api/v1/groups?owner=true')
  }

  getGroup (id:any) {
    return this.http.get(`${this.baseUrl}`+'/api/v1/groups/' + id)
  }

  removeGroup (id:any) {
    return this.http.delete(`${this.baseUrl}`+'/api/v1/groups/' + id)
  }

  removeGroups (ids:any) {
    let data = (typeof ids === 'undefined' ? ids : JSON.stringify({ids: ids}));
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=utf-8',
      }),
      body: {
        data: data,
      },
    };
    return this.http.delete(`${this.baseUrl}`+'/api/v1/groups?_=' + Date.now(),options);
  }

  createGroup () {
    let data = JSON.stringify({'state': 'pending'});
    return this.http.post(`${this.baseUrl}`+'/api/v1/groups',data);
  }

  updateGroup (id:any, data:any) {
    data = JSON.stringify(data);
    return this.http.put(`${this.baseUrl}`+'/api/v1/groups/' + id,data);
  }

}
